'use client'

import { useParams } from 'next/navigation'
import { Button } from '@desoutter/uikit'
import { cn } from '@desoutter/uikit'
import getUrlPrefix from '@/utils/getUrlPrefix'
import { ColoredCardRecord } from '@/graphql/types'
import { LocalizedLink } from '@/components/LocalizedLink'

const backgrounds = {
	'bg-gray-900': 'bg-gray-900 text-white',
	'bg-white': 'bg-white text-gray-900',
	'bg-red-500': 'bg-primary text-white',
}

type ArticleListElementProps = {
	data: ColoredCardRecord
}

export const ColoredCard = ({ data }: ArticleListElementProps) => {
	const { lang } = useParams()

	return (
		<div
			className={cn(
				'flex flex-col justify-between p-12 rounded-2xl mt-16 lg:mt-0 mb-8',
				// 'bg-gray-900 bg-white bg-red-500', // TW hack
				backgrounds[data.backgroundColor] || backgrounds['bg-primary'],
			)}
			style={{ flexGrow: data.span }}
		>
			<div className="xl:w-2/3 2xl:w-3/5">
				<p className="mb-4 text-[2rem] font-medium">{data.title}</p>
				<p className="mb-4 text-[18px] leading-8">{data.text}</p>
			</div>

			<LocalizedLink
				locale={lang}
				href={getUrlPrefix(data.link)}
				prefetch={false}
			>
				<Button variant="outline" color="secondary" title={data.link.label}>
					{data.link.label}
				</Button>
			</LocalizedLink>
		</div>
	)
}
